// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dsZY","placeholdersHeader":"styles_placeholdersHeader__Gpc20","editorStyle":"styles_editorStyle__1XZZQ","placeholdersBox":"styles_placeholdersBox__dc0GA"};